export interface PostQuestionResponse {
    message: {
        id: string;
        role: string;
        content: Array<{
            type: 'text' | 'image_file' | 'file';
            text?: { value: string };
            fileOutputs?: {
                id: string | undefined;
                name: string | undefined;
            }[];
        }>;
    }[];
    threadId: string;
    action?: string;
    responseId: string;
    arguments?: string;
    errors?: Record<string, string>;
}

export interface PreviousMessageResponse {
    id: string;
    role: string;
    content: Array<{
        type: 'text';
        text?: { value: string };
        fileOutputs?: { id: string | undefined; name: string | undefined }[];
    }>;
    containerId?: string;
    created_at: string;
}

export interface AssistantMessage {
    id: string;
    isGpt: boolean;
    content: Array<{
        type: 'text';
        text: { value: string };
        fileOutputs?: { id: string | undefined; name: string | undefined }[];
    }>;
    time?: string;
    temp?: boolean;
}

export interface MultiDynamicField {
    title: string;
    description: string;
}

export interface SingleDynamicField {
    value: string;
}

export enum ToolTypeEnum {
    FileSearch = 'file_search',
    CodeInterpreter = 'code_interpreter',
}
